import * as React from 'react';
// import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const LiveClassPlayer = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    data-id="live-class-player"
    className={cn('flex w-full flex-col rounded-[12px] bg-white p-3 shadow-dropshadow-sm', className)}
    {...props}
  />
));
LiveClassPlayer.displayName = 'LiveClassPlayer';

const LiveClassPlayerEmbed = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    data-id="live-class-player-embed"
    className={cn('relative aspect-[16/9] [&_iframe]:absolute [&_iframe]:h-full [&_iframe]:w-full ...', className)}
    {...props}
  />
));
LiveClassPlayerEmbed.displayName = 'LiveClassPlayerEmbed';

export { LiveClassPlayer, LiveClassPlayerEmbed };
